import { Box, styled } from '@mui/material';

import { OneLinkStyle } from './NavLinks.types';

const linkWidthPadding = 8;
const linkBorderRadius = 8;
const gapBetweenLinks = 16;

export const NavLinksContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  columnGap: `${gapBetweenLinks}px`,

  margin: 'auto 0',

  '@media screen and (max-width: 1280px)': {
    columnGap: `${gapBetweenLinks / 4}px`,
  },
}));

export const OneLink = styled(Box)(
  ({ main, secondary, highlight }: OneLinkStyle) => ({
    position: 'relative',
    padding: `2px ${linkWidthPadding}px`,
    borderRadius: `${linkBorderRadius}px`,

    fontSize: '18px',
    color: secondary,
    textTransform: 'uppercase',
    fontFamily: 'SignikaMedium',

    cursor: 'pointer',

    '&:hover': {
      color: main,
    },

    '&:hover:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: `${linkWidthPadding}px`,
      display: 'block',
      width: `calc(100% - ${linkWidthPadding * 2}px)`,
      height: '3px',
      backgroundColor: main,
      borderRadius: '3px 3px 0 0',
    },

    '&.active': {
      backgroundColor: highlight,
    },

    '&:hover.active': {
      backgroundColor: 'transparent',
    },

    transition: 'background-color .3s linear',

    '@media screen and (min-width: 1920px)': {
      fontSize: '24px',
    },

    '@media screen and (max-width: 1280px)': {
      fontSize: '14px',
    },

    '@media screen and (max-width: 640px)': {
      fontSize: '12px',
    },
  }),
);
